import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName:
        "6-Up audio module to hold content, each item requires media type `audioImage`.",
    description:
        "The items for this module come from nested modules with nestedVariation = AlternateFirstItems.",
    links: [
        {
            name: "Figma",
            url: "https://www.figma.com/design/bMBv4BuIvJVKOSw6LryZRr/Audio?node-id=2787-2132&m=dev",
        },
    ],
};
